import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store/store';
import './common/mixin';
import './utils/lib-flexible/flexible'

import {Popup,Toast,Collapse,CollapseItem,List,Field,Form,Swipe,SwipeItem,Button,Icon,
PullRefresh,Area} from 'vant';
import 'vant/lib/index.css';

Vue.use(ElementUI);
Vue.use(Popup);
Vue.use(Toast);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(List);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Field);
Vue.use(Form);
Vue.use(Button);
Vue.use(Icon);
Vue.use(PullRefresh);
Vue.use(Area);



window.eventBus = new Vue()

import App from './App'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js